<template>
	<BasicTile gradient-direction="none" class="reward-tile base-tile__border-upper rounded-12">

		<template v-slot:image>
			<div class="reward-tile__image-container">
				<img :src="imageUrl" class="reward-tile__image" />
			</div>
		</template>

		<div class="reward-tile__append-bottom-container">
			<slot name="payout-name"></slot>
		</div>

	</BasicTile>
</template>

<script setup lang="ts">
import BasicTile from '@/components/Tiles/Basic-Tile.vue';

const props = defineProps({
	imageUrl: String,
});
</script>

<style lang="scss" scoped>
// test
</style>